import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormEdit } from '../components';
import Swal from 'sweetalert2';
import schema from './schema'
import { showObservacao, loadObservacoes, updateObservacao } from '~/store/modules/observacao/action';
import { Loading } from '~/components';

const Edit = ({entidade_id}) => {
  let history = useHistory();
  const [observacao_edit, setObservacaoEdit] = useState(null);
  const [saved, setSaved] = useState(false);
  const { observacao_id }  = useParams();
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors, observacao } = useSelector(({ ObservacaoReducer }) => ObservacaoReducer);

  useEffect(() => {
    dispatch(showObservacao(observacao_id));
  }, [dispatch, observacao_id]);


  useEffect(() => {
    // console.log('errors Edit: ',errors);
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.update) {
      setSaved(errors.update);
    }
  }, [errors]);

  useEffect(() => {
    if (observacao !== {}) {
      setObservacaoEdit({
        descricao: observacao.descricao,
      });
    }
  }, [observacao, status_response]);

  useEffect(() => {
    if (saved && status_response === 200) {
      Swal.fire('Sucesso', 'Registro editado com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadObservacoes({
            where:`entidade_id:${entidade_id}`,
          }));
        }
      );
    }
  }, [status_response, history, dispatch, saved, entidade_id]);


  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setErrorsValidate([]);
    if (!schema.isValidSync(observacao_edit)) {
      let yup_errors = {};
      schema.validate(observacao_edit, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      const nova_observacao = observacao_edit;
      nova_observacao.entidade_id = parseInt(entidade_id);
      console.log('observacao_edit update: ',nova_observacao);
      await dispatch(updateObservacao(nova_observacao, observacao_id));
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Observação
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            {
              observacao_edit?
                (
                  <FormEdit
                    errors={errorsValidate}
                    handleSubmit={handleSubmit}
                    observacao={observacao_edit}
                    schema={schema}
                    setObservacao={setObservacaoEdit}
                  />
                ):
                (
                  <Loading />
                )
            }
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </button>
        <button
          className="btn btn-success"
          form="form_observacao"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Editar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;
